import Vue from 'vue'
import VueRouter from 'vue-router'
import Releases from '@/views/Releases.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Releases',
    component: Releases,
    props: { privateRelease: false }
  },
  {
    path: '/merch',
    name: 'Merch',
    beforeEnter() {
      window.location.href = 'https://Carlacafe.squarespace.com'
    }
  },
  {
    path: '/:wildcard',
    name: 'Wildcard',
    component: Releases,
    props: { privateRelease: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
